import { apiClient } from '@/shared/lib/api/api-client'
import type { ViolationsEnvelope } from '@/shared/lib/api/violations'
import type { Role, RoleCatalogRow, RolePayload } from '../types/role'

/** `POST api/roles/validate` always answers 200; nothing is persisted. */
export interface RoleValidation extends ViolationsEnvelope {
  Valid: boolean
  UserCount: number
}

export function fetchRoles(): Promise<Role[]> {
  return apiClient.get<Role[]>('/api/roles')
}

export function fetchRoleCatalog(): Promise<RoleCatalogRow[]> {
  return apiClient.get<RoleCatalogRow[]>('/api/roles/catalog')
}

export function createRole(payload: RolePayload): Promise<Role> {
  return apiClient.post<Role>('/api/roles', payload)
}

export function updateRole(id: number, payload: RolePayload): Promise<Role> {
  return apiClient.put<Role>(`/api/roles/${id}`, payload)
}

export function validateRole(payload: RolePayload, id?: number, signal?: AbortSignal): Promise<RoleValidation> {
  const query = id === undefined ? '' : `?id=${id}`
  return apiClient.post<RoleValidation>(`/api/roles/validate${query}`, payload, signal)
}

export function deleteRole(id: number): Promise<void> {
  return apiClient.delete<void>(`/api/roles/${id}`)
}
